import React from 'react'
import { ListGroup } from 'react-bootstrap'
import SearchResultMiniSession from './SearchResultMiniSession'

const SearchResultListMiniSessions = ({ miniSessions, searchValue }) => {
  if(miniSessions.data.length === 0) {
    return null
  }

  const params = new URLSearchParams({
    "query[query]" : searchValue,
    "query[show_past]": "true",
    "query[show_future]": "true",
    "query[show_proposals]": "false",
    "query[show_confirmed_events]": "false",
    "query[show_sessions]": "true",
  })
  const moreResultsPath = `/events?${params.toString()}`

  return (
    <div className="mb-3">
      <h5>
        <a href={moreResultsPath} className="text-dark">
          Mini Sessions &raquo;
        </a>
      </h5>
      <ListGroup>
        {miniSessions.data.map(result => (
          <SearchResultMiniSession key={result.id} result={result} />
        ))}
      </ListGroup>
      <div className="text-end mt-2">
        <a className="text-muted" href={moreResultsPath}>Search all mini sessions &raquo;</a>
      </div>
    </div>
  )
}

export default SearchResultListMiniSessions
